<glxy-page #page [pagePadding]="!page.pageMobile">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button (click)="back()"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.SETTINGS_PAGE_TITLE' | translate }}</glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="narrow">
    <div class="config-cards">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.KNOWLEDGE_SOURCES.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          {{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.KNOWLEDGE_SOURCES.SUBTITLE' | translate }}
          <div class="ai-assistant-section">
            <ai-knowledge-application-knowledge
              [appId]="knowledgeInfo().knowledgeAppId"
              (selectedSourcesChange)="updateSelectedSources($event)"
            ></ai-knowledge-application-knowledge>
          </div>
          <glxy-form-field>
            <inbox-subscription-selector
              [subscriptionLevels]="selectedSubscriptionLevels()"
              (selectedSubscriptionLevels)="setSubscriptionLevels($event)"
            ></inbox-subscription-selector>
          </glxy-form-field>
        </mat-card-content>
      </mat-card>
    </div>
    <inbox-sticky-footer (submitClick)="save()"></inbox-sticky-footer>
  </glxy-page-wrapper>
</glxy-page>
